import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { BillSchema } from '../base/bill.js';
export const CheckBillPreReqsRequestSchema = z.object({
    bill: BillSchema.pick({ total: true, vendor: true }),
    entityId: CornSchema,
    additional: z.record(z.string(), z.unknown()).optional(),
});
export const CheckBillPreReqsResponseSchema = z.object({
    result: z.boolean(),
    reasons: z.string().array().optional(),
});
